var version = '7.30.0';

export { version as default };
